'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCreateAccountState = exports.CREATE_ACCOUNT_SUCCESS_LOG_ANALYTICS = exports.CREATE_ACCOUNT_SUCCESS = exports.CREATE_ACCOUNT_REQUEST = exports.CREATE_ACCOUNT_FAIL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.submitCreateAccount = submitCreateAccount;

var _user = require('../modules/user');

var _api = require('../api');

var _bidderExists = require('./bidderExists');

var _reselect = require('reselect');

var _config = require('../modules/config');

var _analytics = require('../modules/analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CREATE_ACCOUNT_FAIL = exports.CREATE_ACCOUNT_FAIL = 'la/ui/createAccount/FAIL';
var CREATE_ACCOUNT_REQUEST = exports.CREATE_ACCOUNT_REQUEST = 'la/ui/createAccount/REQUEST';
var CREATE_ACCOUNT_SUCCESS = exports.CREATE_ACCOUNT_SUCCESS = 'la/ui/createAccount/SUCCESS';
var CREATE_ACCOUNT_SUCCESS_LOG_ANALYTICS = exports.CREATE_ACCOUNT_SUCCESS_LOG_ANALYTICS = 'la/ui/createAccount/LOG_ANALYTICS';

// reducer
var DEFAULT_STATE = {
    error: null,
    submitted: false,
    success: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CREATE_ACCOUNT_FAIL:
            return (0, _extends3.default)({}, state, {
                error: action.payload,
                submitted: false,
                success: false
            });
        case CREATE_ACCOUNT_REQUEST:
            return (0, _extends3.default)({}, state, {
                error: null,
                submitted: true,
                success: false
            });
        case CREATE_ACCOUNT_SUCCESS:
            return (0, _extends3.default)({}, state, {
                error: null,
                submitted: false,
                success: true
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.createAccount;
};

var getCreateAccountState = exports.getCreateAccountState = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

/* ACTION CREATORS */
function submitCreateAccount(emailAddress, attributionData) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        var forceFetchBidderData = true;
        dispatch({
            payload: emailAddress,
            type: CREATE_ACCOUNT_REQUEST
        });
        return _api.Bidder.postCreateAccount({ deployment: deployment, emailAddress: emailAddress }).then(function (response) {
            var token = response.payload.createToken;
            dispatch({
                meta: { actionTime: Date.now() },
                payload: token,
                type: CREATE_ACCOUNT_SUCCESS
            });
            dispatch((0, _user.fetchBidderDataIfNeeded)(token, forceFetchBidderData)).then(function () {
                var userData = (0, _user.getUserData)(getState());
                dispatch({
                    meta: (0, _extends3.default)({}, (0, _analytics.getRegisterAccountAnalytics)(userData.bidderId, attributionData), {
                        actionTime: Date.now()
                    }),
                    payload: userData,
                    type: CREATE_ACCOUNT_SUCCESS_LOG_ANALYTICS
                });
            });
        }).catch(function (error) {
            // Response from Flynn has this format { Payload: { bidderExists?, error?, token?}}
            if (error.payload && error.payload.bidderExists) {
                dispatch((0, _bidderExists.bidderExistsSuccess)(emailAddress));
            }
            if (error.payload && error.payload.error) {
                dispatch({
                    error: true,
                    meta: { emailAddress: emailAddress },
                    payload: error.payload.error,
                    type: CREATE_ACCOUNT_FAIL
                });
            } else {
                // I think this is the proper way to catch a 500 error from the server
                dispatch({
                    error: true,
                    meta: { emailAddress: emailAddress },
                    payload: error.message,
                    type: CREATE_ACCOUNT_FAIL
                });
            }
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/createAccount.js
// module id = FneX
// module chunks = 46